import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {checkAllPromise, GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {Loader} from "@commons/services/presenze_calcolo/Loader";
import {
    listAttestatiINPSPeriodo,
    listPeriodoPresenze,
    listProprietaOrari,
    listProprietaPresenze,
    listRichiesteWFPeriodoFlat,
    listStatoWeeks,
    listStatus,
    listVociDiPianificazionePeriodo,
    savePeriodoPresenze,
} from "@commons/services/presenze_calcolo/GestionePlus.api";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";

import {getCalendarioChiusureByAnno} from "@commons/services/presenze_api/tabellePresenze.api";
import {SituazioneIC} from "@commons/services/presenze_calcolo/SituazioneIC";
import {listUnitaLocali} from "@commons/services/presenze_api/tabelleAzienda.api";
import {DateTime} from "luxon";
import {cloneDeep, merge} from "lodash";
import {AxiosError} from "axios";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {FPNetDate, Periodo} from "@commons/types";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {listLavoratoriPeriodo, PresenzeLavoratoreParams} from "@commons/services/lavoratori/lavoratori.presenze.api";
import {CalendarioChiusureRecord} from "@commons/mapping/CalendarioChiusureRecord";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";
import {ValoreAccumuloParams} from "@commons/services/presenze_api/valoriAccumuli.api";
import {Accumuli} from "@commons/services/presenze_calcolo/sub_calcolo/Accumuli";
import {GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {RiepilogoICParams} from "@commons/services/presenze_api/riepilogoIC.api";
import {AziendaBase} from "@commons/mapping/AziendaNavRecord";

const isDevelopment = () => (process.env.NODE_ENV === 'development');

interface SaveOptions {
    token?: string,
    updateDays?: boolean,
    fromNodeJS?: boolean,
}

const isObject = (yourVariable: any) => {
    return typeof yourVariable === 'object' &&
        !Array.isArray(yourVariable) &&
        yourVariable !== null;
}
export type LoadLavoratoriResult = Promise<{ lavoratori: LavoratorePresenzeRecord[] | null, lavoratore: LavoratorePresenzeRecord | null }>;

export function GestionePlusCommonCtrl(gestione: GestionePlus,
                                       idDominio: number,
                                       idAziendaMaster: number,
                                       idAzienda: number,
                                       idAziendaTabelleDef: number,
                                       idTabellaWF: number,
                                       lavoratoriAux?: LavoratorePresenzeRecord[],
                                       auth_token?: string) {
    /*
        const console = {
            log: (...args: any) => {
            }, error: (...args: any) => {
            }
        }
    */
    const showLog = isDevelopment();
    const showWarn = isDevelopment();

    const getPresenzeLavoratoreParams = (lavoratore?: LavoratorePresenzeRecord): PresenzeLavoratoreParams => ({
        idAziendaMaster: lavoratore?.azienda?.idAziendaMaster || idAziendaMaster!,
        idAzienda: lavoratore?.azienda?.idAzienda || idAzienda!,
        idDip: lavoratore?.id || 0,
        anno: gestione.anno,
        mese: gestione.mese,
        extraInfo: false,
        rilevaPianificazione: false,
        token: auth_token,
    });

    const loader = Loader(auth_token);
    const initCache = (idAziendaTabelle: number = idAziendaTabelleDef): Promise<CachePresenze> => {
        let cache = loader.getCache(idAziendaTabelle);
        return new Promise<CachePresenze>(async (resolve, _reject) => {
            if (!cache || cache.isStale()) {
                loader.purgeCache(idAziendaTabelle);
                cache = await loader.initCache(idDominio, idAziendaTabelle, idTabellaWF);
            }
            gestione.setCache(cache);
            resolve(cache);
        });
    }

    function failed(error: any, reject: (reason?: any) => void) {
        if (isObject(error)) {
            console.error('GestionePlusCommonCtrl: ' + JSON.stringify(error));
        } else if (error) {
            console.error('GestionePlusCommonCtrl: ' + error); // String ???
        } else {
            console.error('GestionePlusCommonCtrl: failed!');
        }
        reject(error);
    }

    const getInizioMese = (): DateTime => {
        const inizioMese = gestione.getInizioMese();
        showLog && console.log('inizioMese', inizioMese.toLocaleString());
        return inizioMese;
    };

    const getFineMese = (): DateTime => {
        const fineMese = gestione.getFineMese();
        showLog && console.log('fineMese', fineMese.toLocaleString());
        return fineMese;
    };

    const consolidaLavoratore = ({minDate, maxDate, calcola}: {
        minDate?: FPNetDate,
        maxDate?: FPNetDate,
        calcola?: boolean,
    }): Promise<void> => {
        const getParamSaldiIC = (lavoratore: LavoratorePresenzeRecord): RiepilogoICParams => ({
            idAziendaMaster: lavoratore.azienda?.idAziendaMaster || idAziendaMaster,
            idDip: lavoratore.id,
            //anno: moment(editor.resource.giornoDt).year(),
            //mese: moment(editor.resource.giornoDt).month()+1,
            anno: gestione.anno,//: DateTime.now().year(),
            mese: gestione.mese,//: DateTime.now().month() + 1,
            rilevaMese: true,
            token: auth_token,
        });
        return new Promise<void>((resolve, reject) => {
            showLog && console.log('consolidaLavoratore - new Promise<void>');
            const _failed = function (error: any) {
                failed(error, reject);
            };

            const chiudiCaricamento = function () {
                if (gestione.lavoratore) {
                    const proprietaGestione = LavoratorePresenzeRecord.getProprieta(gestione.lavoratore, getFineMese());
                    // Fisso calendario chiusure!!!
                    if (proprietaGestione) {
                        gestione.calendarioChiusure = gestione.getCalendario(proprietaGestione);
                    }
                }

                gestione.postConsolidaLavoratore(true, undefined, gestione.lavoratore!).then(function () {
                    gestione!.lavoratore!.loaded = true;
                    /*events.on.completeLoadPresenze().then(function () {
                        resolve();
                    }, _failed);*/
                    resolve();
                }, _failed);
            };

            if (gestione.lavoratore) {
                const idAziendaTabelle = gestione.lavoratore.azienda?.idAziendaCDIC || idAziendaTabelleDef;
                showLog && console.log('consolidaLavoratore - gestione.lavoratore.loaded = false');
                showLog && console.log("isFrozen: " + Object.isFrozen(gestione.lavoratore))
                gestione.lavoratore.loaded = false;
                showLog && console.log('consolidaLavoratore - call preConsolidaLavoratore');
                showWarn && console.warn('consolidaLavoratore - call preConsolidaLavoratore');
                gestione.preConsolidaLavoratore(undefined, undefined, gestione.lavoratore).then(function () {
                    showLog && console.log('consolidaLavoratore - call loadHHWeekLavoratore');
                    loadHHWeekLavoratore().then(function () {
                        loadStatusLavoratore().then(function () {
                            loadProprietaLavoratore().then(function () {
                                let carica: boolean = true;
                                if (minDate && getInizioMese() < DateTime.fromISO(minDate))
                                    carica = false;
                                if (maxDate && getFineMese() > DateTime.fromISO(maxDate))
                                    carica = false;
                                if (carica) {
                                    loadWeeksAndPresenze(calcola).then(chiudiCaricamento, _failed);
                                } else {
                                    gestione.weeks = [];
                                    gestione.totaliMese = null;
                                    setupPresenze([]);
                                    chiudiCaricamento();
                                }
                            }, _failed);
                        }, _failed);
                    }, _failed);
                }, _failed);

                if (gestione.caricaIC) {
                    if (gestione.ic === null) {
                        gestione.ic = new SituazioneIC(idAziendaTabelle);
                    }
                    if (gestione.ic.tabellaIC.length === 0)	// solo prima volta...
                    {
                        // carico tabella istituti contrattuali azienda
                        SituazioneIC.caricaIstituti(gestione.ic, {idAziendaTabelle, token: auth_token}).then(function () {
                            SituazioneIC.caricaSaldi(gestione.ic!, getParamSaldiIC(gestione.lavoratore!));
                        }, _failed);
                    } else {
                        SituazioneIC.caricaSaldi(gestione.ic, getParamSaldiIC(gestione.lavoratore!));
                    }
                }

            } else {
                reject();
            }
        });
    };

    const setLavoratoreByIndex = (index: number, data: Pick<LavoratorePresenzeRecord, 'id'>[], minDate?: FPNetDate,
                                  maxDate?: FPNetDate, calcola?: boolean): Promise<LavoratorePresenzeRecord | null> => {
        if (index >= 0 && index < data.length) {
            return setLavoratoreById(data[index].id, true, minDate, maxDate, calcola);
        } else {
            return new Promise<LavoratorePresenzeRecord | null>((resolve, reject) => {
                resolve(null);
            })
        }
    };

    const setLavoratoreById = (id: number, ricarica: boolean = true,
                               minDate?: FPNetDate,
                               maxDate?: FPNetDate,
                               calcola?: boolean,
                               rejectOnError: boolean = false) => {
        return new Promise<LavoratorePresenzeRecord | null>(async (resolve, reject) => {
                if (!gestione.elencoLavoratori)
                    reject();

                showWarn && console.warn('setLavoratoreById, elencoLavoratori', gestione.elencoLavoratori)
                const lavoratore = gestione.elencoLavoratori!.find((lav) => lav.id === id);
                showWarn && console.warn('setLavoratoreById lavoratore', lavoratore, id)
                if (lavoratore) {
                    const idAzienda = lavoratore.azienda?.idAziendaCDIC || idAziendaTabelleDef
                    /**
                     * N.B. Il client DEVE garantire l'accesso all'azienda tabelle "forzando" l'azienda corrente su backend con la seguente chiamata:
                     * const tokenResult = await cambiaAzienda({idAzienda});
                     */
                    const cache = await initCache(idAzienda); // fisso cache al variare del lavoratore

                    showLog && console.log('setLavoratoreById', id);
                    gestione.lavoratore = lavoratore;
                    if (!gestione.lavoratore.loaded || ricarica) {
                        showLog && console.log('chiamo consolidaLavoratore', id);
                        showWarn && console.warn('chiamo consolidaLavoratore', id);
                        //await consolidaLavoratore({minDate, maxDate, calcola}).then(() => resolve(gestione.lavoratore), reject);
                        try {
                            await consolidaLavoratore({minDate, maxDate, calcola});
                            resolve(gestione.lavoratore);
                        } catch (err) {
                            if (rejectOnError)
                                reject(err);
                            else
                                resolve(gestione.lavoratore); // Risolvo comunque anche in caso di problemi con le presenze, sarà compito del chiamante di verificare se le presenze ci sono o meno
                        }
                    } else {
                        resolve(null);
                    }
                } else {
                    reject();
                }
            }
        );
    };

    const getLavoratore = () => gestione ? gestione.lavoratore : null;
    /*const events = {
        on:
            {
                completeLoadLavoratori: setLavoratoreByIndex, // passa due parametri: un indice e lo array dei lavoratori; l'indice rappresenta l'elemento da selezionare se >=0
                completeLoadPresenze: solved,
            }
    };*/

    const showError = (error: any) => console.log('ERRORE' + JSON.stringify(error));

    /**
     * Carica le unita locali, N.B. solo se pagina su azienda master!
     * @returns {*} promise
     */
    const loadUnitaLocali = (azienda: Pick<AziendaBase, 'idAziendaMaster' | 'idAzienda' | 'codAzienda'>, loadUL: boolean = false): Promise<AziendaRecord[]> => {
        gestione.elencoUnitaLocali = [];
        return new Promise<AziendaRecord[]>((resolve, reject) => {
            if (!azienda || (!loadUL && azienda.idAzienda !== azienda.idAziendaMaster)) {
                resolve([]);
            } else {
                listUnitaLocali({idAziendaMaster: azienda.idAzienda, view: 'Minimal', filter_codAzienda: azienda.codAzienda, token: auth_token}).then(
                    (data) => {
                        gestione.elencoUnitaLocali = data;
                        resolve(data);
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    })
            }
        });
    }

    const loadTabelleAnno = ({idAziendaCDIC}: Pick<AziendaBase, 'idAziendaCDIC'>, anno: number, mode: 'presenze' | 'workflow' = 'presenze'): Promise<{
        calendarioChiusure: CalendarioChiusureRecord | null
    }> => {
        return new Promise<{ calendarioChiusure: CalendarioChiusureRecord | null }>((resolve, _reject) => {
            if (mode === 'presenze')
                resolve({calendarioChiusure: null});
            else {
                getCalendarioChiusureByAnno({idAzienda: idAziendaCDIC, anno, auth_token}).then(
                    (data) => {
                        gestione.calendarioChiusure = data;
                        resolve({calendarioChiusure: data});
                    },
                    (_err) => {
                        gestione.calendarioChiusure = null;
                        resolve({calendarioChiusure: null});
                        // NON sempre il calendario è presente!
                        //showError(err);
                        //reject(err);
                    })
            }
        });
    }

    const listLavoratori = (_params: PresenzeLavoratoreParams, _employeeOrder: boolean = false, _user: UserCRUDRecord | null = null) => {
        return new Promise<LavoratorePresenzeRecord[]>((resolve, reject) => {
            if (lavoratoriAux && lavoratoriAux.length)
                resolve(cloneDeep(lavoratoriAux));
            else reject();
        });
    }

    const hasCalcolaPresenze = (user: Pick<UserCRUDRecord, 'userClass'> | null, cachePresenze: CachePresenze | null) => {
        if (!gestione.isPaginaWF) return false;

        const isEmployee = user?.userClass === 'EMPLOYEE';
        //if (!isEmployee) return false;

        if (!cachePresenze) return false;
        if (!!cachePresenze.tabellaWF?.calcolaPresenze) {
            let calcola: boolean;
            const oggi = DateTime.now().startOf('day');
            if (oggi.year === gestione.anno && oggi.month === gestione.mese) {
                calcola = true;
            } else {
                calcola = true;
                const startDate = Periodo.getInizioMese(gestione); // inizio mese
                const fineMese = Periodo.getFineMese(gestione); // fine mese
                if (oggi > fineMese.plus({day: cachePresenze.tabellaWF.calcolaFinoAl})) {
                    calcola = false; // NON calcolo perché oggi è successivo all'ultimo giorno utile per calcolare il mese precedente
                }
                if (oggi < startDate) {
                    calcola = false; // NON calcolo perché oggi è precedente il periodo di inizio
                }
            }
            return calcola;
        }
        return false;
    };

    /**
     * Carica i lavoratori
     * @param idDip l'eventuale id del lavoratore da pre selezionare
     * @param selFirst in alternativa, se true, seleziona il primo lavoratore della lista!
     * @param extraInfo
     * @param employeeOrder
     * @param user
     * @returns {*} promise
     */
    const loadLavoratori = (idDip: number | null = null,
                            selFirst: boolean = false,
                            extraInfo: boolean = false,
                            employeeOrder: boolean = false,
                            user: UserCRUDRecord | null = null): LoadLavoratoriResult => {
        const api = (lavoratoriAux && lavoratoriAux.length) ? listLavoratori : listLavoratoriPeriodo;
        return new Promise<{ lavoratori: LavoratorePresenzeRecord[] | null, lavoratore: LavoratorePresenzeRecord | null }>((resolve, reject) => {
            gestione.elencoLavoratori = null;
            gestione.elencoLavoratoriInAnomalia = null;
            gestione.lavoratore = null;
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams();
            api({...presenzeLavoratoreParams, extraInfo, rilevaPianificazione: gestione.isPaginaPianificazione}, employeeOrder, user).then(
                function (lavoratori) {
                    gestione.elencoLavoratoriInAnomalia = [];
                    gestione.elencoLavoratori = lavoratori;
                    //showWarn && console.warn('gestione.elencoLavoratori',lavoratori)
                    let index2Sel = -1;

                    for (let ind0 = 0; ind0 < lavoratori.length; ++ind0) {
                        if (idDip) {
                            if (idDip === lavoratori[ind0].id) {
                                index2Sel = ind0;
                            }
                        }
                        if (LavoratorePresenzeRecord.hasAnomalie(lavoratori[ind0])) {
                            gestione.elencoLavoratoriInAnomalia.push(lavoratori[ind0].id);
                        }
                    }

                    // Se il lavoratore nn è stato trovato e come seconda opzione si desidera selezionare il primo della lista...
                    if (index2Sel === -1 && selFirst) {
                        index2Sel = 0;
                    }
                    // fix busy per elenco lavoratori nullo!!!
                    if (lavoratori.length === 0) {
                        gestione.isBusy = false;
                    }
                    const calcola = hasCalcolaPresenze(user, gestione.getCache());
                    //const promise = events.on.completeLoadLavoratori(index2Sel, lavoratori, undefined, undefined, calcola);
                    const promise = setLavoratoreByIndex(index2Sel, lavoratori, undefined, undefined, calcola);
                    if (promise) {
                        promise.then((lavoratore) => {
                                resolve({lavoratori, lavoratore: lavoratore});
                            },
                            //reject
                            (err) => {
                                resolve({lavoratori, lavoratore: null});
                            }
                        )
                        ;
                    } else {
                        resolve({lavoratori, lavoratore: gestione.lavoratore});
                    }
                },

                function (error: AxiosError) {
                    console.error('loadLavoratori(): ' + JSON.stringify(error));
                    reject(error);
                }
            );
        });
    };

    const loadHHWeekLavoratore = (reload: boolean = false) => new Promise<void>((resolve, reject) => {
        if (gestione.lavoratore && (!gestione.lavoratore.orarioProprieta || reload)) {
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore);
            showLog && console.log('loadHHWeekLavoratore INIZIO');
            showLog && console.log("isFrozen: " + Object.isFrozen(gestione.lavoratore))
            listProprietaOrari(presenzeLavoratoreParams).then(
                function (data) {
                    showLog && console.log('loadHHWeekLavoratore FINE');
                    gestione.lavoratore!.orarioProprieta = data;
                    resolve();
                },
                function (err) {
                    showLog && console.log('ERRORE' + JSON.stringify(err));
                    gestione.lavoratore!.orarioProprieta = [];
                    reject(err);
                }
            );
        } else {
            resolve();
        }
    });

    const loadStatusLavoratore = (reload: boolean = false) => new Promise<void>((resolve, reject) => {
        if (!gestione.lavoratore)
            resolve();
        const lavoratore = gestione.lavoratore!;

        if (!lavoratore.status || reload) {
            showLog && console.log('loadStatusLavoratore INIZIO');
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(lavoratore);
            listStatus(presenzeLavoratoreParams).then(
                function (data) {
                    /*
                                        if (lavoratore.id===3374){
                                            console.log(lavoratore.id)
                                        }
                    */
                    const requests: Promise<void>[] = [];
                    lavoratore.status = data || [];
                    lavoratore.status // filtro HIRED e FIRED che non hanno giustificativi associati
                        .filter(({codice}) => codice !== 'HIRED')
                        .filter(({codice}) => codice !== 'FIRED')
                        .forEach(({codice}) => {
                            requests.push(loader.loadGiustificativiXStatus(lavoratore.azienda!.idAziendaCDIC, codice));
                        });
                    /*
                                        for (let ind0 = 0; ind0 < data.length; ++ind0) {
                                            const tabelle = data[ind0];
                                            requests.push(loader.loadGiustificativiXStatus(lavoratore.azienda!.idAziendaCDIC, tabelle.codice));
                                        }
                    */
                    checkAllPromise(requests, resolve, showLog ? 'loadStatusLavoratore' : undefined);
                },
                function (err) {
                    /*
                                        if (lavoratore.id===3374){
                                            console.log(lavoratore.id)
                                        }
                    */
                    showLog && console.log('ERRORE' + JSON.stringify(err));
                    gestione.lavoratore!.status = [];
                    reject(err);
                }
            );
        } else {
            resolve();
        }
    });

    const loadProprietaLavoratore = (reload: boolean = false) => new Promise<void>((resolve, reject) => {
        if (!gestione.lavoratore)
            resolve();
        const lavoratore = gestione.lavoratore!;
        if (!lavoratore.proprieta || reload) {
            showLog && console.log('loadProprietaLavoratore INIZIO');
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(lavoratore);
            listProprietaPresenze(presenzeLavoratoreParams).then(
                function (data) {
                    lavoratore.proprieta = data;
                    loader.loadTabelleProprieta(lavoratore.azienda!.idAziendaCDIC, data, presenzeLavoratoreParams.anno).then(
                        function () {
                            showLog && console.log('loadProprietaLavoratore FINE');
                            resolve();
                        });
                },
                function (err) {
                    showLog && console.log('ERRORE' + JSON.stringify(err));
                    lavoratore.proprieta = null;
                    reject(err);
                }
            );
        } else {
            resolve();
        }
    });

    const loadWeeksAndPresenze = (calcola: boolean = false) => new Promise<void>((resolve, reject) => {
        const onSuccess = () => resolve();
        const onFail = (err: any) => reject(err);
        loadWeeks().then(function () {
            loadPresenze(calcola).then(function () {
                loadAccumuli().then(onSuccess, onFail);
            }, onFail);
        }, onFail);
    });

    const loadAccumuli = () => new Promise<void>((resolve, reject) => {
        const onSuccess = () => {
            showLog && console.log('loadAccumuli, ex postConsolidaLavoratore: FINE');
            resolve();
        }
        const aggiornaAccumuli = true;
        try {
            if (aggiornaAccumuli) {// && this.totaliMese!==null) {
                if (gestione.totaliMese === null) {
                    throw {message: `Manca lo sviluppo del mese ${gestione.anno}-${gestione.mese}!`};
                }

                const lavoratore = gestione.lavoratore!;
                const days = gestione.days!;
                const cache = gestione.getCache();
                // Aggiorno riepilogo accumuli di controllo
                gestione.totaliMese.accumuliCHK = [];
                const accumuliANNO = [];

                // Determino parametri per la rotta '/azienda/:idAzienda/accumulo/:codAccumulo?idDip=:idDip&dataIniziale=:dataIniziale&dataFinale=:dataFinale'
                const params: ValoreAccumuloParams = {
                    idAzienda: lavoratore.idAziendaMaster,
                    idDip: lavoratore.id,
                    codAccumulo: '',
                    dataIniziale: gestione.anno + '0101',
                    dataFinale: gestione.anno + '1231',
                    dataInizioPeriodo: DateTime.fromISO(days[0].dtGiornata!).toFormat('yyyyLLdd'),
                    dataFinePeriodo: DateTime.fromISO(days[days.length - 1].dtGiornata!).toFormat('yyyyLLdd'),
                    token: auth_token
                };

                for (let indCHK = 0; indCHK < cache.accumuliCHK.length; ++indCHK) {
                    const accumulo = cache.accumuliCHK[indCHK];
                    let addAccumulo = (!accumulo.listaStatus || accumulo.listaStatus.length === 0); // N.B. <accumulo.listaStatus> e' solo un array di stringhe!!!
                    if (!addAccumulo && lavoratore.status) { // Nessuno status oppure il lavoratore ha lo status del controllo
                        for (let indStatus = 0; indStatus < lavoratore.status.length; ++indStatus) { // status lavoratore nel mese
                            if (accumulo.listaStatus.indexOf(lavoratore.status[indStatus].codice) >= 0) {
                                addAccumulo = true;
                                break;
                            }
                        }
                    }

                    if (addAccumulo) {
                        const accumuloClone = AccumuloRecord.factory(accumulo);
                        gestione.totaliMese.accumuliCHK.push(accumuloClone);
                        if (accumuloClone.periodo === 'ANNO' || accumuloClone.periodo === 'VALIDITA') {
                            params.codAccumulo = accumuloClone.id!;
                            accumuloClone.params = JSON.parse(JSON.stringify(params));
                            accumuliANNO.push(accumuloClone);
                        }
                    }
                }
                if (accumuliANNO.length > 0) {
                    // Mi appoggio alla cache impropriamente per caricare i valori degli accumuli interessati al lavoratore...

                    CachePresenze.getValoriAccumuli(accumuliANNO).then(function () {
                        // Chiamare calcolo saldi al periodo (fine mese???)
                        //that.aggiornaSaldiAccumuli(null);
                        Accumuli.aggiornaSaldiAccumuli(gestione, null, null);

                        onSuccess();
                    }, onSuccess);
                } else {
                    onSuccess();
                }
            } else {
                onSuccess();
            }
        } catch (e: any) {
            reject(e.message);
        }
    });

    const loadWeeks = (reload: boolean = false) => new Promise<void>((resolve, reject) => {
        const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore || undefined);
        listStatoWeeks(presenzeLavoratoreParams).then(
            function (data) {

                gestione.weeks = [];
                gestione.totaliMese = null;
                for (let ind0 = 0; ind0 < data.length; ++ind0) {
                    if (data[ind0].numWeek < 99) {
                        gestione.weeks.push(data[ind0]);
                        //showLog && console.log(res.data[ind0]);
                    } else {
                        gestione.totaliMese = data[ind0];
                    }
                }
                showLog && console.log('loadWeeks FINE');
                resolve();

            },
            function (error: AxiosError) {
                gestione.weeks = null;
                console.error('loadWeeks(): ' + JSON.stringify(error));
                reject();
            }
        );
    });

    const setupPresenze = (data: PresenzeGiornataPlusRecord[]): Promise<any>[] => {
        gestione.days = data;
        const turniDaCaricare: { idAziendaTabelle: number, codTurno: number }[] = []; // Elenco dei turni da caricare (quelli usati nel periodo)
        for (let indDay = 0; indDay < gestione.days.length; ++indDay) {
            const day = gestione.days[indDay];
            const idAziendaTabelle = day.idAziendaTabelle;
            // Fisso indice! (da 0 a max 41)
            day.index = indDay;
            day.causaliHH = day.causaliHH ?? [];
            if (day.causaliHH.length === 0) {
                day.causaliHH.push(PresenzeGiustificativo.factory());
            } else {
                // Normalizza quantitaHHMM
                day.causaliHH.forEach(causaleHH => {
                    if (causaleHH) {
                        PresenzeGiustificativo.setHHCC(causaleHH, causaleHH.quantita);
                    }
                });
            }
            day.causaliQI = day.causaliQI ?? [];
            if (day.causaliQI.length === 0) {
                day.causaliQI.push(PresenzeGiustificativo.factory());
            }

            if (day.codTurno > 0 && !turniDaCaricare.find(t => t.codTurno === day.codTurno)) {
                turniDaCaricare.push({idAziendaTabelle, codTurno: day.codTurno});
            }
            if ((day.codTurnoSviluppo > 0 && day.codTurnoSviluppo !== day.codTurno) && !turniDaCaricare.find(t => t.codTurno === day.codTurnoSviluppo)) {
                turniDaCaricare.push({idAziendaTabelle, codTurno: day.codTurnoSviluppo});
            }
            if ((day.codTurnoPianificazione > 0 && day.codTurnoPianificazione !== day.codTurno) && !turniDaCaricare.find(t => t.codTurno === day.codTurnoPianificazione)) {
                turniDaCaricare.push({idAziendaTabelle, codTurno: day.codTurnoPianificazione});
            }
        }
        GestionePlusData.normalizzaDays(gestione);

        // AGGIORNO TOTALI SETTIMANALI
        if (gestione.weeks)
            for (let indWeek2 = 0; indWeek2 < gestione.weeks.length; ++indWeek2) {
                const week2 = gestione.weeks[indWeek2];
                // Normalizzo oggetto week
                week2.index = indWeek2;
                week2.hired = false;
                week2.giustificativi = [];
                gestione.updateTotaliWeekEAccumuli(week2);
            }

        // AGGIORNO TOTALI MESE
        gestione.updateTotaliMese();
        gestione.allineaIstituti();

        // RESET GESTIONE
        gestione.modified = false;

        const requests: Promise<any>[] = [];
        if (gestione.days.length) {

            // Terminate tutte le inizializzazioni, eseguo backup di ogni singola giornata!
            if (gestione.backupDays) {
                for (let ind0 = 0; ind0 < gestione.days.length; ++ind0) {
                    PresenzeGiornataPlusRecord.backup(gestione.days[ind0]);
                }
            }

            // Carico turni!
            turniDaCaricare.forEach(({idAziendaTabelle, codTurno}) => requests.push(loader.loadTurno(idAziendaTabelle, codTurno)));

            // Solo se è presente la tabella per l'azienda allora carico anche gli eventuali giustificativi per il lavoratore!
            gestione.causaliWF = [];
            if (gestione.caricaRichiesteWF && gestione.hasWF() && gestione.lavoratore && gestione.lavoratore.hasWF) {
                requests.push(loadRichiesteWFLavoratore());
            }

            gestione.vociPianificazione = [];
            if (gestione.isPaginaPianificazione) {
                if (gestione.lavoratore && LavoratorePresenzeRecord.hasPianificazione(gestione.lavoratore)) {
                    requests.push(loadVociDiPianificazioneLavoratore());
                }
            }

            gestione.giustificativiAttestati = [];
            if (gestione.lavoratore && gestione.lavoratore.hasMalattia) {
                requests.push(loadGiustificativiAttestati());
            }
        }
        return requests;
    }

    const loadPresenze = (calcola: boolean = false) => new Promise<void>((resolve, reject) => {
        showLog && console.log('loadPresenze INIZIO');
        const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore || undefined);
        listPeriodoPresenze({...presenzeLavoratoreParams, calcola}).then(data => {
                const requests = setupPresenze(data)
                Promise.all(requests).then(
                    function () {
                        showLog && console.log('loadPresenze FINE');
                        resolve();
                    },
                    function (error: AxiosError) {
                        failed(error, reject);
                    }
                );
            },
            function (error: AxiosError) {
                gestione.days = null;
                failed(error, reject);
            }
        );
    });

    const loadRichiesteWFLavoratore = (reload: boolean = true) => new Promise<void>((resolve, reject) => {
        if (reload) {
            showLog && console.log('loadRichiesteWFLavoratore INIZIO');
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore || undefined);
            listRichiesteWFPeriodoFlat(presenzeLavoratoreParams).then(
                function (data) {
                    showLog && console.log('loadRichiesteWFLavoratore FINE');
                    gestione.causaliWF = data;
                    resolve();
                },
                function (err) {
                    gestione.causaliWF = [];
                    failed(err, reject);
                }
            );
        } else {
            resolve();
        }
    });

    const loadVociDiPianificazioneLavoratore = (reload: boolean = true) => new Promise<void>((resolve, reject) => {
        if (reload) {
            showLog && console.log('loadVociDiPianificazioneLavoratore INIZIO');
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore || undefined);
            listVociDiPianificazionePeriodo(presenzeLavoratoreParams, gestione.isPaginaWF).then(
                function (data) {
                    showLog && console.log('loadVociDiPianificazioneLavoratore FINE');
                    gestione.vociPianificazione = data;
                    resolve();
                },
                function (err) {
                    gestione.vociPianificazione = [];
                    failed(err, reject);
                }
            );
        } else {
            resolve();
        }
    });

    const loadGiustificativiAttestati = (reload: boolean = true) => new Promise<void>((resolve, reject) => {
        if (reload) {
            showLog && console.log('loadGiustificativiAttestati INIZIO');
            const presenzeLavoratoreParams = getPresenzeLavoratoreParams(gestione.lavoratore || undefined);
            listAttestatiINPSPeriodo(presenzeLavoratoreParams).then(
                function (data) {
                    showLog && console.log('loadGiustificativiAttestati FINE');
                    gestione.giustificativiAttestati = data;
                    resolve();
                },
                function (err) {
                    gestione.giustificativiAttestati = [];
                    failed(err, reject);
                }
            );
        } else {
            resolve();
        }
    });

    const getElenco = () => gestione.elencoLavoratori ? gestione.elencoLavoratori : [];
    const getLavoratorePrev = function (): LavoratorePresenzeRecord | null {
        if (gestione.lavoratore) {
            const elenco = getElenco();
            for (let indElenco = 0; indElenco < elenco.length; ++indElenco) {
                if (elenco[indElenco].id === gestione.lavoratore.id) {
                    if (indElenco > 0) {
                        --indElenco;
                    }
                    return elenco[indElenco];
                }
            }
        }
        return gestione.lavoratore;
    };
    const getLavoratoreNext = function (): LavoratorePresenzeRecord | null {
        if (gestione.lavoratore) {
            const elenco = getElenco();
            for (let indElenco = 0; indElenco < elenco.length; ++indElenco) {
                if (elenco[indElenco].id === gestione.lavoratore.id) {
                    if (indElenco < elenco.length - 1) {
                        ++indElenco;
                    }
                    return elenco[indElenco];
                }
            }
        }
        return gestione.lavoratore;
    };

    const getDaysToSave = function (days: PresenzeGiornataPlusRecord[] | null = gestione.days) {
        const daysToSave = [];
        if (days)
            for (const day of days) {
                if (day.modified) {
                    const {backup, currentTurno, ...rest} = day;
                    const clone = days === gestione.days ? day : cloneDeep(rest);
                    if (days === gestione.days) {
                        showLog && console.log('Uso GESTIONE!');
                    }
                    clone.causaliHH = PresenzeGiornataPlusRecord.defrag(clone.causaliHH);
                    clone.causaliQI = PresenzeGiornataPlusRecord.defrag(clone.causaliQI);
                    clone.week = {totali: clone.week!.totali} as StatoWeekPLUSRecord; // In AngularJS veniva fatto con toJSON...
                    daysToSave.push(clone);
                }
            }
        return daysToSave;
    };

    /**
     *
     * @param mute true -> Calcolo massivo, nessun messaggio e no merge dopo save
     * @param chiudiPeriodo
     * @param livelloChiusura
     * @param _toastLabel
     * @param notificaAnomalie
     * @param pianificazione
     * @param days
     * @returns {*}
     * @private
     */
    const _salva = async (mute: boolean = false,
                          chiudiPeriodo: boolean = false,
                          livelloChiusura: number | undefined = undefined,
                          _toastLabel: string | null = null,
                          notificaAnomalie: boolean = false,
                          pianificazione: boolean = false,
                          days: PresenzeGiornataPlusRecord[] | null = gestione.days, options?: SaveOptions): Promise<PresenzeGiornataPlusRecord[]> =>
        new Promise<PresenzeGiornataPlusRecord[]>((resolve, reject) => {
            /*
                    mute = mute || false;
                    chiudiPeriodo = chiudiPeriodo || false;
                    livelloChiusura = livelloChiusura || null;
                    notificaAnomalie = notificaAnomalie || false;
            */
            gestione.isBusy = true;
            const daysToSave = getDaysToSave(days);
            if (daysToSave.length > 0) {
                // Rimuovo backup e turno
                if (days === gestione.days) { // Solo per gestione.days! In caso si operi sui lavoratori le due proprietà vengono rimosse da getDaysToSave
                    for (let ind0 = 0; ind0 < daysToSave.length; ++ind0) {
                        // @ts-ignore
                        delete daysToSave[ind0].backup;
                        // @ts-ignore
                        delete daysToSave[ind0].currentTurno;
                    }
                }
                // da vedere l'utilizzo di <JSON.stringify(baz, ["foo"]);> per filtrare le proprietà da inviare!
                savePeriodoPresenze({
                    idDip: daysToSave[0].idDip,
                    chiudiPeriodo,
                    livelloChiusura,
                    opeMassiva: mute,
                    notificaAnomalie,
                    pianificazione,
                    token: options?.token,
                    fromNodeJS: options?.fromNodeJS,
                }, daysToSave)
                    .then(function (daysSaved) {
                        if (!mute || options?.updateDays) {
                            if (gestione.days === days)
                                daysSaved.forEach(item => {
                                    //const daySaved = PresenzeGiornataPlusRecord.factory(item);
                                    const daySaved = item;
                                    // Cerco giornata in that._gestione.days
                                    for (let ind1 = 0; ind1 < gestione.days!.length; ++ind1) {
                                        const day = gestione.days![ind1];

                                        if (day.dtGiornata === daySaved.dtGiornata) {
                                            //merge(day, daySaved);
                                            if (!options || options?.updateDays) {
                                                const {modified, lastUpdateTrace} = daySaved;
                                                merge(day, {modified, lastUpdateTrace});
                                            }
                                            if (gestione.backupDays) {
                                                if (!options) {
                                                    // Ripristino backup e currentTurno
                                                    PresenzeGiornataPlusRecord.backup(day);
                                                }
                                            }
                                            day.currentTurno = null;
                                            break;
                                        }
                                    }
                                });
                        }
                        gestione.modified = false;
                        gestione.isBusy = false;
                        resolve(daysSaved);
                        if (!mute) {
                            //MyNoty.notySuccess(toastLabel || 'Presenze salvate correttamente!'); todo!
                        }
                    }, function (error: AxiosError) {
                        if (!mute) {
                            //popup.showError(error.data.message); todo!
                        } else {
                            console.error(error);
                        }
                        gestione.isBusy = false;
                        // @ts-ignore
                        reject(error.response ? error.response.data.message : 'Errore!');
                    });
            } else {
                gestione.isBusy = false;
                resolve([]);
            }
        });

    return {
        initCache,
        loadUnitaLocali,
        loadTabelleAnno,
        loadLavoratori,
        setLavoratoreById,
        setLavoratoreByIndex,
        getLavoratore,
        getLavoratorePrev,
        getLavoratoreNext,
        getDaysToSave,
        _salva,
        hasCalcolaPresenze
    }
}

export type GPReturnType = ReturnType<typeof GestionePlusCommonCtrl>;